module.exports = __webpack_public_path__ + "img/general-bg-3.dec45400.svg";